import { Component, OnInit,ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonApiService } from '../../common-api.service';
import { JournalVoucher } from './journal-voucher.interface';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { Router } from '@angular/router';
import { SnackbarService } from '../../snackbar.service';
import { MatSelect } from '@angular/material/select';
import { CommonDropdownService } from '../../common-dropdown.service';
import { environment } from "../../../../environments/environment";
import { tap, filter, finalize } from 'rxjs/operators';
import { Company } from '../company/company.interface';
import { Doctor } from '../doctor/doctor.interface';
import { DateStorageService } from '../../date-storage.service';

@Component({
    selector: 'app-journal-voucher.form',
    templateUrl: './journal-voucher.form.component.html',
    styleUrls: ['./journal-voucher.form.component.css']
})

export class JournalVoucherFormComponent implements OnInit {

    @ViewChild('doctor_id', { static: false }) doctor_id: MatSelect;
    @ViewChild('account_id', { static: false }) account_id: MatSelect;
    @ViewChild('company_id', { static: false }) company_id: MatSelect;
    constructor(
        private route: ActivatedRoute,
        private api: CommonApiService,
        private router: Router,
        public dialog: MatDialog,
        private snackbar: SnackbarService,
        private dropdownService: CommonDropdownService,
        private dateStorageService: DateStorageService
    ) { }


    public model = 'journal_voucher'
    public journal_voucher = {} as JournalVoucher;
    isFormDisabled = true;
    result: string;
    onSaveDisable = false;


    doctorSearchPage = 0;
    allDoctorsCount = 0
    public allDoctors: any[] = [];
    public selectedCreditDoctor: any;
    public selectedDebitDoctor: any;
    public selectedDoctorObject: any[] = [];
    disableDoctorSelection: boolean;

    accountSearchPage=0
    allAccountsCount = 0
    public allAccounts: any[] = [];
    public selectedCreditAccount: any;
    public selectedDebitAccount: any;
    public selectedAccountObject: any[] = [];
    disableAccountSelection: boolean;

    companySearchPage=0
    allCompaniesCount = 0
    public allCompanies: any[] = [];
    public selectedCompany: number;
    public selectedCompanyObject: Company[] = [];
    disableCompanySelection: boolean;

    selectedDebitType:any;
    selectedCreditType:any;

    minDate: Date | null = new Date();
    maxDate: Date | null = new Date();

    ngOnInit() {
        this.disableCompanySelection=false
        this.disableDoctorSelection=false
        let journal_voucher_Id = this.route.snapshot.params.id
        if (journal_voucher_Id === 'create') {
            this.isFormDisabled = false;
        }
        else {
            this.disableCompanySelection=true
            this.disableDoctorSelection=true
            this.getJournalVoucher(Number(journal_voucher_Id));
        }
        this.onLoadDoctorList();
        this.OnLoadCompanyList();
        
        this.minDate = this.dateStorageService.getDateFromLocalStorage('fy_start_date')
        this.maxDate = this.dateStorageService.getDateFromLocalStorage('fy_end_date')
    }


    onDoctorKey(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        this.dropdownService.updateSearchResults(value, 'doctor', this.allDoctors, this.selectedDoctorObject, 'doctorSearchPage')
          .subscribe((result: { entityList: any[], pageVariable: number }) => {
            this.allDoctors = result.entityList;
            this.doctorSearchPage = result.pageVariable;
        });
    }
    OnCompanyKey(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        this.dropdownService.updateSearchResults(value, 'company', this.allCompanies, this.selectedCompanyObject, 'companySearchPage')
          .subscribe((result: { entityList: any[], pageVariable: number }) => {
            
            this.allCompanies = result.entityList;
            this.companySearchPage = result.pageVariable;
        });
    }

    onAccountKey(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        this.dropdownService.updateSearchResults(value, 'account', this.allAccounts, this.selectedAccountObject, 'accountSearchPage')
          .subscribe((result: { entityList: any[], pageVariable: number }) => {
            this.allAccounts = result.entityList;
            this.accountSearchPage = result.pageVariable;
        });
    }

    onDoctorScroll(event:any) {

        if (!this.doctor_id?.panel || !this.doctor_id?.panel.nativeElement) {
            // Panel or nativeElement is not available, return or handle the situation accordingly.
            return;
        }
        if (event) {
            this.doctor_id.panel.nativeElement.addEventListener(
            'scroll',   
            (event: any) => {
                const tolerance = 10
                if (
                    Math.floor(this.doctor_id.panel.nativeElement.scrollTop) + tolerance >= 
                    Math.floor(this.doctor_id.panel.nativeElement.scrollHeight) -
                    Math.floor(this.doctor_id.panel.nativeElement.offsetHeight)
                    ){
                    let doctorparams = {
                        'pageIndex': this.doctorSearchPage,
                        'pageSize': environment.defaultPageSizeOnScroll
                    }
                    
                    if (this.allDoctors.length >= this.allDoctorsCount) {
                        return;
                    }
                    this.api.postAll('doctor/list/display', doctorparams).subscribe((res: any) =>{
                        res.items = res.items.filter((entity: any) => entity.id !== this.selectedDoctorObject[0]?.id);
                        this.allDoctors.push(...res.items);
                    });
                    this.doctorSearchPage++;// send page number for fetching the records
                }
            });
        }
    }


    OnCompanyScroll(event:any) {
        if (!this.company_id?.panel || !this.company_id?.panel.nativeElement) {
            // Panel or nativeElement is not available, return or handle the situation accordingly.
            return;
        }
        if (event) {
            this.company_id.panel.nativeElement.addEventListener(
            'scroll',   
            (event: any) => {
                const tolerance = 10
                if (
                    Math.floor(this.company_id.panel.nativeElement.scrollTop) + tolerance >= 
                    Math.floor(this.company_id.panel.nativeElement.scrollHeight) -
                    Math.floor(this.company_id.panel.nativeElement.offsetHeight)
                    ){
                    let companyparams = {
                        'pageIndex': this.companySearchPage,
                        'pageSize': environment.defaultPageSizeOnScroll
                    }
                    
                    if (this.allCompanies.length >= this.allCompaniesCount) {
                        return;
                    }
                    this.api.postAll('company/list/display', companyparams).subscribe((res: any) =>{
                        res.items = res.items.filter((entity: any) => entity.id !== this.selectedCompanyObject[0]?.id);
                        this.allCompanies.push(...res.items);
                    });
                    this.companySearchPage++;// send page number for fetching the records
                }
            });
        }
    }


    onAccountScroll(event:any) {
        if (!this.account_id?.panel || !this.account_id?.panel.nativeElement) {
            // Panel or nativeElement is not available, return or handle the situation accordingly.
            return;
        }
        if (event) {
            this.account_id.panel.nativeElement.addEventListener(
            'scroll',   
            (event: any) => {
                const tolerance = 10
                if (
                    Math.floor(this.account_id.panel.nativeElement.scrollTop) + tolerance >= 
                    Math.floor(this.account_id.panel.nativeElement.scrollHeight) -
                    Math.floor(this.account_id.panel.nativeElement.offsetHeight)
                    ){
                    let accountparams = {
                        'pageIndex': this.accountSearchPage,
                        'pageSize': environment.defaultPageSizeOnScroll
                    }
                    
                    if (this.allAccounts.length >= this.allAccountsCount) {
                        return;
                    }
                    this.api.postAll('account/list/display', accountparams).subscribe((res: any) =>{
                        res.items = res.items.filter((entity: any) => entity.id !== this.selectedAccountObject[0]?.id);
                        this.allAccounts.push(...res.items);
                    });
                    this.accountSearchPage++;// send page number for fetching the records
                }
            });
        }
    }


    // On load of component default pageSize for dropdown to load and also set selected value if present
    onLoadDoctorList() {
        let params = {
            'pageIndex': this.doctorSearchPage,
            'pageSize': environment.defaultPageSizeOnScroll
        }

        this.api.postAll('doctor/list/display', params).pipe(
            tap((res: any) => {
                this.allDoctors.push(...res.items);
                this.allDoctorsCount = res.rowCount
            }),
            filter(() => this.selectedDoctorObject.length !== 0),
            tap(() => {
              const selectedDoctorId = this.selectedDoctorObject[0].id;
              this.allDoctors = this.allDoctors.filter(doctor => doctor.id !== selectedDoctorId);
              this.allDoctors.unshift(this.selectedDoctorObject[0]);
              
            }),
            finalize(() => this.doctorSearchPage++)
        ).subscribe();
    }
    OnLoadCompanyList() {
        this.api.getAll('company').pipe(
            tap((res: any) => {
                this.allCompanies=res
            }),
            filter(() => this.selectedCompanyObject.length !== 0),
            tap(() => {
              const selectedCompanyId = this.selectedCompanyObject[0].id;
              this.allCompanies = this.allCompanies.filter(company => company.id !== selectedCompanyId);
              this.allCompanies.unshift(this.selectedCompanyObject[0]);         
            }),
        ).subscribe();
    }

    OnLoadAccountList() {
        let params = {
            'pageIndex': this.accountSearchPage,
            'pageSize': environment.defaultPageSizeOnScroll,
            'filterCriteria': {
                'company_id': ['dropdown', this.selectedCompany],
                'type': ['=', ['other']],
                "order_by_columns": [
                    "multi_select",
                    null
                ],
                "order_by": "asc"
            }
        }
        this.api.postAll('account/list/display', params).pipe(
            tap((res: any) => {
                this.allAccounts.push(...res.items);
                this.allAccountsCount = res.rowCount
            }),
            filter(() => this.selectedAccountObject.length !== 0),
            tap(() => {
              const selectedAccountId = this.selectedAccountObject[0].id;
              this.allAccounts = this.allAccounts.filter(account => account.id !== selectedAccountId);
              this.allAccounts.unshift(this.selectedAccountObject[0]);
              
            })
        ).subscribe();
    }

    getJournalVoucher(journal_voucher_Id: number) {
        this.api.get(this.model, journal_voucher_Id).subscribe(
            (data: any) => {
                if (data) {
                    this.journal_voucher = data;
                    this.selectedCompany = data.company_id;

                    this.OnLoadAccountList();

                    if (data.debit_account_doctor){
                        this.selectedDebitType = 'doctor'
                        this.selectedDebitDoctor = data.debit_account_doctor.id;
                    }

                    if (data.credit_account_doctor_id){
                        this.selectedCreditType = 'doctor'
                        this.selectedCreditDoctor = data.credit_account_doctor_id;
                    }

                    if (data.debit_account_internal){
                        this.selectedDebitType = 'internal'
                        this.selectedDebitAccount = data.debit_account_internal_id;
                    }

                    if (data.credit_account_internal_id){
                        this.selectedCreditType = 'internal'
                        this.selectedCreditAccount = data.credit_account_internal_id;
                    }
                    
                }
            }
        );
    }



    save(formValid:any) {
        if(formValid == false){
            this.snackbar.warning("Please fill mandatory fields.");
            return;
        }
        
        this.journal_voucher.company_id=this.selectedCompany

        if (this.selectedCreditType == 'internal') {
            if (this.selectedCreditAccount == undefined) {
                this.snackbar.warning("Please select Account");
                return
            }
            this.journal_voucher.credit_account_internal_id = this.selectedCreditAccount            
        } else {
            this.selectedCreditAccount = undefined
            this.journal_voucher.credit_account_internal_id = this.selectedCreditAccount
        }

        if (this.selectedCreditType == 'doctor') {
            if (this.selectedCreditDoctor == undefined) {
                this.snackbar.warning("Please select Doctor");
                return
            }
            this.journal_voucher.credit_account_doctor_id = this.selectedCreditDoctor
        } else {
            this.selectedCreditDoctor = undefined
            this.journal_voucher.credit_account_doctor_id = this.selectedCreditDoctor
        }

        if (this.selectedDebitType == 'internal') {
            if (this.selectedDebitAccount == undefined) {
                this.snackbar.warning("Please select Account");
                return
            }
            this.journal_voucher.debit_account_internal_id = this.selectedDebitAccount
        } else {
            this.selectedDebitAccount = undefined
            this.journal_voucher.debit_account_internal_id = this.selectedDebitAccount
        }

        if (this.selectedDebitType == 'doctor') {
            if (this.selectedDebitDoctor == undefined) {
                this.snackbar.warning("Please select Doctor");
                return
            }
            this.journal_voucher.debit_account_doctor_id = this.selectedDebitDoctor
        } else {
            this.selectedDebitDoctor = undefined
            this.journal_voucher.debit_account_doctor_id = this.selectedDebitDoctor
        }

        var uniqueSelectionList = [this.journal_voucher.credit_account_internal_id, this.journal_voucher.credit_account_doctor_id, this.journal_voucher.debit_account_internal_id, this.journal_voucher.debit_account_doctor_id]        
        
        const filteredSet = new Set(uniqueSelectionList.filter(x => x !== undefined));
        if (filteredSet.size !== new Set(filteredSet).size) {
            this.snackbar.warning('Debit and Credit Account can be same!');
            return;
        }
    
        this.onSaveDisable = true;
        this.api.createUpdate(this.model, this.journal_voucher).subscribe(
            (data: any) => {
                if (data) {
                    this.journal_voucher = data;
                    this.isFormDisabled = true;
                    this.snackbar.success('Saved Successfully!');
                    this.onSaveDisable = false;
                }
            },
            error => {
                this.snackbar.error(error.error.message)
                this.onSaveDisable = false;
            }
        );

        
    }
    edit(){
        this.isFormDisabled = false;
        this.disableCompanySelection=true
        this.disableDoctorSelection=true
    }

    discardChanges(): void {
		const message = `Are you sure you want to discard the changes?`
		const dialogConfig = new MatDialogConfig();
		dialogConfig.data = {
			title: "Discard Changes",
			message: message
		}
		const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			// return true or false or undefined , hence we can handle the functionality on true and false likewise here
			
			if (this.result) {
                if(this.journal_voucher.id){
                    this.isFormDisabled = true;
                    this.getJournalVoucher(this.journal_voucher.id);
                }else{
                    this.router.navigate([`/journal_voucher`]);
                }
			}
		});
	}

   

    create(){
        this.redirectTo('journal_voucher/create');
    }



    //redirects to the expected route
    //this function will redirect to a dummy route and quickly return to the destination route without the user realizing it.
    redirectTo(uri:string){  
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
        this.router.navigate([uri]));
    }

    confirmDialog(journal_voucher_Id: number, state:string): void {

		var dialog_message = '';
		if(state == 'submit') {
			dialog_message = 'Submit';
		} else if(state == 'cancel') {
			dialog_message = 'Cancel';
		}

		const message = 'Are you sure you want to '+dialog_message+' journal_voucher?'
		const dialogConfig = new MatDialogConfig();
		dialogConfig.data = {
			title: dialog_message+" journal_voucher",
			message: message
		}
		const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			// return true or false or undefined , hence we can handle the functionality on true and false likewise here
			if (this.result) {
				if (state == 'submit') {
					this.submitJournalVoucher(journal_voucher_Id);
				} else if(state == 'cancel'){
					this.canceJournalVoucher(journal_voucher_Id);
				}
			}
		});
	}

    submitJournalVoucher(journal_voucher_Id: number) {
		this.api.callRoute('journal_voucher', `/submit/${journal_voucher_Id}`, null).subscribe(
			(data: any) => {
				if (data) {
					this.journal_voucher = data;
					this.isFormDisabled = true;
					this.snackbar.success('Submitted Successfully!');
				}
			},
			error => {
				this.snackbar.error(error.error.message)
				console.log(error)
			}
		);
	}


	canceJournalVoucher(journal_voucher_Id: number) {
		this.api.callRoute('journal_voucher', `/cancel/${journal_voucher_Id}`, null).subscribe(
			(data: any) => {
				if (data) {
					this.journal_voucher = data;
					this.isFormDisabled = true;
					this.snackbar.success('Cancelled Successfully!');
				}
			},
			error => {
				this.snackbar.error(error.error.message)
				console.log(error)
			}
		);
	}
    
    onCompanyChange() {        
        this.allAccounts = [];
        this.selectedAccountObject = [];
        this.selectedCreditAccount = undefined;
        this.selectedDebitAccount = undefined;
        this.OnLoadAccountList();
    }

}
